import { ServiceBayDto, ServiceBayScheduleDto } from "../dtos/serviceBayDto";
import { ServiceBay, ServiceBaySchedule } from "../models/serviceBay";
import ApiService from "../services/api";

export const createServiceBay = async (
  serviceBay: ServiceBay
): Promise<{ data?: ServiceBay; error?: string }> => {
  const apiService = new ApiService();
  try {
    const response = await apiService.post<any>(`/service-bay`, serviceBay);
    if (response.status === 200) {
      return { data: ServiceBayDto(response.data) };
    } else return { error: "Erro ao criar box" };
  } catch (error: any) {
    console.error(error);
    if (error?.status === 422) {
      return { error: error.response.data?.message || "Erro ao criar box" };
    }
    return { error: "Erro ao criar box" };
  }
};

export const updateServiceBay = async (
  serviceBay: ServiceBay
): Promise<ServiceBay | undefined> => {
  const apiService = new ApiService();
  try {
    const response = await apiService.put<any>(
      `/service-bay/${serviceBay.id}`,
      serviceBay
    );
    if (response.status === 200) {
      return ServiceBayDto(response.data);
    } else return undefined;
  } catch (error) {
    console.error(error);
    return undefined;
  }
};

export const deleteServiceBay = async (
  serviceBayId: string
): Promise<{ result: boolean; error?: string }> => {
  const apiService = new ApiService();
  try {
    const response = await apiService.delete<any>(
      `/service-bay/${serviceBayId}`
    );
    return {
      result: response.status === 200,
      error: response.status !== 200 ? response.data.message : undefined,
    };
  } catch (error: any) {
    console.error(error);
    if (error?.status === 422) {
      return {
        result: false,
        error: error.response.data?.message || "Erro ao deletar box",
      };
    }
    return { result: false, error: "Erro ao deletar box" };
  }
};

export const createServiceBaySchedule = async (
  serviceBaySchedule: any
): Promise<{ result?: boolean; error?: string }> => {
  const apiService = new ApiService();
  try {
    const response = await apiService.post<any>(`/service-bay-schedule`, {
      startDate: serviceBaySchedule.startDate
        ? new Date(
            new Date(serviceBaySchedule.startDate).getTime() -
              3 * 60 * 60 * 1000
          ).toISOString()
        : null,
      endDate: serviceBaySchedule.endDate
        ? new Date(
            new Date(serviceBaySchedule.endDate).getTime() - 3 * 60 * 60 * 1000
          ).toISOString()
        : null,
      occurrenceUuid: serviceBaySchedule.occurrence,
      serviceBayId: serviceBaySchedule.serviceBay,
    });
    if (response.status === 200) {
      return { result: true };
    } else return { error: "Erro ao criar agendamento" };
  } catch (error: any) {
    console.error(error);
    if (error?.status === 422) {
      return {
        error:
          error.response.data?.message ||
          "Preencha todos os campos obrigatórios.",
      };
    }
    return { error: "Erro ao criar agendamento" };
  }
};

export const updateServiceBaySchedule = async (
  serviceBaySchedule: ServiceBaySchedule
): Promise<{ data?: ServiceBaySchedule; error?: string }> => {
  const apiService = new ApiService();
  try {
    const response = await apiService.put<any>(
      `/service-bay-schedule/${serviceBaySchedule.id}`,
      {
        startDate: serviceBaySchedule.startDate?.toISOString(),
        endDate: serviceBaySchedule.endDate?.toISOString(),
        serviceBayId: serviceBaySchedule.serviceBay?.id,
      }
    );
    if (response.status === 200) {
      return { data: ServiceBayScheduleDto(response.data) };
    } else return { error: "Erro ao atualizar agendamento" };
  } catch (error: any) {
    console.error(error);
    if (error?.status === 422) {
      return {
        error: error.response.data?.message || "Erro ao atualizar agendamento",
      };
    }
    return { error: "Erro ao atualizar agendamento" };
  }
};

export const deleteServiceBaySchedule = async (
  serviceBayScheduleId: string
): Promise<{ result: boolean; error?: string }> => {
  const apiService = new ApiService();
  try {
    const response = await apiService.delete<any>(
      `/service-bay-schedule/${serviceBayScheduleId}`
    );
    return {
      result: response.status === 200,
      error: response.status !== 200 ? response.data.message : undefined,
    };
  } catch (error: any) {
    console.error(error);
    if (error?.status === 422) {
      return {
        result: false,
        error: error.response.data?.message || "Erro ao deletar agendamento",
      };
    }
    return { result: false, error: "Erro ao deletar agendamento" };
  }
};
